<section [formGroup]="frmSupplyDetails">
  <div>
    <div
      class="field-holder w2"
      *ngIf="(usState$ | async) == 'TX'
        && ((commodityType$ | async)
            ?? CommodityType.Electricity) === CommodityType.Electricity"
    >
      <mat-checkbox id="bundledRateCheckbox" color="primary" formControlName="bundledRate" (change)="formDataChange()">
        <span>Bundled Rate</span>
      </mat-checkbox>
    </div>

    <section class="field-group">
      <div class="field-holder w2">
        <mat-form-field>
          <mat-label>Utility</mat-label>
          <mat-select id="utilityShort" formControlName="utilityShort" (selectionChange)="selectUtility($event.value)">
            <mat-option value="">-- Please Select --</mat-option>
            <mat-option *ngFor="let utility of (utilityInformation$ | async) || []" [value]="utility.utilityShort">{{
              utility.utilityShort
            }}</mat-option>
          </mat-select>
          <mat-error *ngIf="frmSupplyDetails.get('utilityShort')?.errors?.required"> Please select a Utility </mat-error>
          <mat-error *ngIf="!frmSupplyDetails.get('utilityShort')?.errors?.valid && this.displayError">
            Sorry, {{ userIdentity?.currentOrganisation?.name }} does not quote for this utility
          </mat-error>
        </mat-form-field>
        <mat-error *ngIf="(utility$ | async) && !(utilityUOM$ | async)">Sorry, the selected utility is not supported</mat-error>
      </div>

      <div class="field-holder w2" *ngIf="(commodityType$ | async) === CommodityType.Electricity">
        <mat-form-field floatLabel="always">
          <mat-label>ISO</mat-label>
          <input
            id="iso"
            matInput
            type="text"
            formControlName="iso"
            [value]="(iso$ | async) ?? ''"
            (input)="formDataChange()"
            (change)="formDataChange()"
          />
          <mat-error>Please enter a valid ISO</mat-error>
        </mat-form-field>
      </div>

      <div class="field-holder w2" *ngIf="((commodityType$ | async) ?? CommodityType.Electricity) === CommodityType.Electricity">
        <mat-form-field>
          <mat-label>Zone</mat-label>
          <mat-select id="zone" formControlName="zone" [(value)]="selectedZone" (selectionChange)="selectZone()">
            <mat-option value="">-- Please Select --</mat-option>
            <mat-option *ngFor="let zone of (zones$ | async) || []" [value]="zone">{{ zone }}</mat-option>
          </mat-select>
          <mat-error> Please select a Zone </mat-error>
        </mat-form-field>
      </div>

      <div
        class="field-holder w2"
        *ngIf="(usState$ | async) == 'TX' && ((commodityType$ | async) ?? CommodityType.Electricity) === CommodityType.Electricity"
      >
        <mat-form-field>
          <mat-label>Weather Zone</mat-label>
          <mat-select id="weatherZone" formControlName="weatherZone" (selectionChange)="selectWeatherZone($event.target?.value)">
            <mat-option value="">-- Please Select --</mat-option>
            <mat-option *ngFor="let weatherZone of (weatherZones$ | async) || []" [value]="weatherZone">{{ weatherZone }}</mat-option>
          </mat-select>
          <mat-error> Please select a Weather Zone </mat-error>
        </mat-form-field>
      </div>
    </section>
    <!-- <pre [ngStyle]="{ 'background-color': this.frmSupplyDetails?.valid ? 'palegreen' : 'red' }" style="position: fixed; top: 100px; right: 400px; padding: 10px;">SupplyDetails: {{this.frmSupplyDetails?.getRawValue() | json}}</pre> -->
  </div>
</section>
